var poll_default = {
  "fontElementMap": "_0MmLI",
  "container": "G5Ro4",
  "fullscreen": "wM-05",
  "background_overlay": "q-EuA",
  "with_image": "_-2lcD",
  "options": "nqIwM",
  "webview": "_1Oxb1",
  "grid": "J3r5S",
  "option": "QgfA7",
  "cta_button": "_0FSEc",
  "add_option": "odY4g",
  "see_more": "pcjy7",
  "list": "m2Chm",
  "column": "_1X7S7",
  "additional_note": "_1Y54P",
  "spinner": "yWvo4",
  "spin": "Ktk0n",
  "shown": "xXHBM",
  "error": "_4bIKO"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
